// export.ts — CSV export of the miniatures catalog (all local; nothing leaves the device).
// Exports the units roster with faction + recipe names resolved for a portable backup.

import type { Faction, Recipe, Unit } from "./store";
import { statusLabel } from "./store";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** Units CSV: Faction, Unit, Points, Models, Status, Recipe, WIP since, Notes. */
export function unitsCsv(units: Unit[], factions: Faction[], recipes: Recipe[]): string {
  const factionName = new Map(factions.map((f) => [f.id, f.name]));
  const recipeName = new Map(recipes.map((r) => [r.id, r.name]));
  return csv(
    ["Faction", "Unit", "Points", "Models", "Status", "Recipe", "WIP since", "Notes"],
    units.map((u) => [
      factionName.get(u.faction_id) ?? "",
      u.name,
      u.points,
      u.model_count,
      statusLabel(u.status),
      u.recipe_id ? recipeName.get(u.recipe_id) ?? "" : "",
      u.wip_since ?? "",
      u.notes ?? "",
    ]),
  );
}

export function buildExport(units: Unit[], factions: Faction[], recipes: Recipe[]): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  return { csv: unitsCsv(units, factions, recipes), filename: `muster-units-${stamp}.csv` };
}
